import React from 'react'

import Button from '../common/button'
import KeyboardListener, { KeyCode, KeyBinding } from '../common/keyboard-listener'

type Props = {
  title?: string
  onSave: () => void
  onDiscard: () => void
  onClose: () => void
}

function ConfirmLeaveDialog ({ title = 'Leave', onSave, onDiscard, onClose }: Props) {
  return (
    <div>
      <h2 className='mt0'>{title}</h2>
      <p>You have unsaved changes. Would you like to save your progress?</p>
      <div className='flex justify-end items-end mt3'>
        <Button className='ml2' onClick={onDiscard}>Discard</Button>
        <Button btnType='primary' className='ml2' onClick={onSave}>Save</Button>
      </div>
      <KeyboardListener
        bindings={[
          KeyBinding(KeyCode.enter, onSave),
          KeyBinding(KeyCode.esc, onClose),
        ]}
      />
    </div>
  )
}

export default ConfirmLeaveDialog
